<template>
  <slot-button 
    @click="$emit('click', $event)"
    :text="text" 
    :block="block" 
    :icon="icon" 
    :disabled="disabled"
    :title="title"
    :btnClass="btnClass + ' image-button'"
    :x-small="xSmall"
    :small="small"
    :medium="medium"
    :large="large"
    :x-large="xLarge"
    :fab="fab"
    :btnColor="btnColor">
    <background-image :image="image"/>
  </slot-button>
</template>

<script>
import backgroundImage from "./BackgroundImage";
import slotButton from "./SlotButton";
export default {
  name: "imageButton",
  components: { backgroundImage, slotButton },
  props: {
    text: { type: Boolean, default: true },
    block: Boolean,
    icon: Boolean,
    image: { type: String, default: "trash-icon.png" },
    disabled: Boolean,
    title: { type: String, default: "" },
    btnClass:  { type: String, default: "" },
    xSmall: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    xLarge: { type: Boolean, default: false },
    fab: { type: Boolean, default: false},
    btnColor: {type: String, default: ""}
  }
};
</script>
